
export function agruparAcessosPorEntidade(acessos) {
  const agrupados = [];
  _.forEach(acessos, (acesso) => {
    const jaAgrupado = _.find(agrupados, agrupado => agrupado.entidade === acesso.values.entity);
    if (!jaAgrupado) {
      agrupados.push({
        entidade: acesso.values.entity,
        context: acesso.context,
      });
    }
  });
  return agrupados;
}

export function filterAcessosPorSistema(acessos, sistema) {
  const entidades = _.filter(acessos, (acesso) => {
    return acesso.system === sistema;
  });
  return _.map(entidades, (acesso) => {
    return {
      database: acesso.values.database,
      entidade: acesso.values.entity,
      technical: acesso.technical,
      admin: acesso.admin
    };
  });
}

export function atribuirNomesEntidades(userAccountsService) {
  return (entidadesWrapper) => {
    const ids = _.map(entidadesWrapper, wrapper => wrapper.entidade);
    return userAccountsService.entitiesInfo(ids).then((infos) => {
      _.forEach(entidadesWrapper, (wrapper) => {
        wrapper.nome = _.find(infos, info => parseInt(wrapper.entidade, 10) === info.id).name;
      });
      return entidadesWrapper;
    });
  };
}

export function encodeIdSistemas(sistemas) {
  if (!sistemas) return;

  sistemas.forEach((sistema) => {
    sistema.encodedId = btoa(sistema.id);
  });
  return sistemas;
}

export function atribuirIcones(sistemas) {
  if (!sistemas) return;

  sistemas.forEach((sistema) => {
    sistema.icone = (_.find(propriedades, { id: sistema.id }) || propriedadeDefault).icone;
  });
  return sistemas;
}
